import React from 'react'
import Entrylist from '../components/Entrylist'
import AddEntry from '../components/AddEntry'
import { Row, Col } from 'reactstrap'
import Search from '../components/Search'
import { withRouter } from 'react-router-dom'
import { fetchEntries, searchEntries, saveEntry, deleteEntry } from '../api'

class EntriesContainer extends React.Component {
  constructor() {
    super()
    this.state = {
      loading: false,
      search: false,
      entries: []
    }
  }
  componentDidMount() {
    console.log('localstorage', window.localStorage)
    this.getEntries();
  }

  getEntries = () => {
    console.log('getEntries')
    this.setState({ loading: true, search: false, entries: [] })
    fetchEntries().then(res => {
        this.setState({ entries: res.data, loading: false })
      }).catch(err => {
        console.log(err.response)
        if (err.response.status === 401) {
          this.props.history.push('/login')            
        }
      })
  }

  searchEntries = search => {
    this.setState({ loading: true, search: search })
    searchEntries(search).then(res => {
        this.setState({ entries: res.data })
      }).catch(err => {
        this.setState({ entries: [] })
      }).finally(() => {
        this.setState({ loading: false })
      })
  }

  saveEntry = entry => {
    this.setState({ loading: true })
    saveEntry(entry).then(() => {
        this.getEntries();
      }).finally(() => {
        this.setState({ loading: false })
      })
  }

  deleteEntry = guid => {
    if (window.confirm("Are you sure?")) {
      this.setState({ loading: true })
      deleteEntry(guid).then(res => {
          this.getEntries();
        }).finally(() => {
          this.setState({ loading: false })
        })
    }
  }

  search = val => {
    console.log('search', val)
    if (val.length > 1) {
      this.setState({ activeSearch: val })
      this.searchEntries(val)
    } else {
      this.setState({ activeSearch: '' })
      this.fetchEntries()
    }
  }

  render() {
    return (
      <div>
        {this.state.loading && (
          <h1>Loading...</h1>
        )}
        <Search
          search={this.search}
        />
        <Row>
          <Col xs="12>">&nbsp;</Col>
        </Row>
        <Entrylist
          entries={this.state.entries}
          search={this.state.activeSearch}
          deleteEntry={this.deleteEntry}
          searchEntries={this.search}
        />
        <AddEntry save={this.saveEntry} />
      </div>
    )
  }
}

export default withRouter(EntriesContainer)
